import get from 'lodash.get'

function findEdgeLabelConfig (edgeLabels, fromLevelId, toLevelId) {
  if (!Array.isArray(edgeLabels)) return null
  return edgeLabels.find(el => el.from === fromLevelId && el.to === toLevelId) || null
}

function buildPathKey (ancestorIds, levelId, entityId) {
  return [...ancestorIds, `${levelId}-${entityId}`].join('/')
}

function normalizeFieldConfig (config) {
  if (!config) return null
  if (typeof config === 'string') return { accessor: config }
  return config
}

function resolveFieldValue (row, fieldConfig) {
  if (!fieldConfig) return undefined
  const raw = get(row, fieldConfig.accessor)
  if (raw == null) return undefined
  const prefix = fieldConfig.prefix ? `${fieldConfig.prefix} ` : ''
  return `${prefix}${raw}`
}

export function buildFromHierarchy (items, levels, edgeLabels) {
  if (!items.length || !levels.length) return { nodes: [], edges: [] }

  const nodeMap = new Map()
  const edgeMap = new Map()

  items.forEach(row => {
    const ancestorIds = []

    levels.forEach((level, levelIndex) => {
      const entityId = get(row, level.idAccessor)
      if (entityId == null) return

      const entityKey = String(entityId)
      const pathKey = buildPathKey(ancestorIds, level.id, entityKey)

      if (!nodeMap.has(pathKey)) {
        const nameConfig = normalizeFieldConfig(level.name)
        const descConfig = normalizeFieldConfig(level.description)

        nodeMap.set(pathKey, {
          id: pathKey,
          type: 'flowGraphCard',
          position: { x: 0, y: 0 },
          data: {
            nameConfig,
            descriptionConfig: descConfig,
            nameValue: resolveFieldValue(row, nameConfig),
            descriptionValue: resolveFieldValue(row, descConfig),
            variant: level.variant || 'default',
            size: level.size || 'md',
            levelId: level.id,
            levelIndex,
            raw: row
          }
        })
      }

      if (levelIndex > 0 && ancestorIds.length > 0) {
        const parentPathKey = ancestorIds[ancestorIds.length - 1]
        const edgeKey = `${parentPathKey}->${pathKey}`

        if (!edgeMap.has(edgeKey)) {
          const parentLevel = levels[levelIndex - 1]
          const labelConfig = findEdgeLabelConfig(edgeLabels, parentLevel.id, level.id)

          const edge = {
            id: `e-${edgeKey}`,
            source: parentPathKey,
            target: pathKey
          }

          if (labelConfig) {
            const rawLabel = get(row, labelConfig.accessor)
            if (rawLabel != null) {
              edge.label = rawLabel
              edge.data = { label: rawLabel, format: labelConfig.format }
              edge.type = 'labeled'
            }
          }

          edgeMap.set(edgeKey, edge)
        }
      }

      ancestorIds.push(pathKey)
    })
  })

  return {
    nodes: Array.from(nodeMap.values()),
    edges: Array.from(edgeMap.values())
  }
}
